import BonConsultation from '@/components/caisse/factures/print-bons/bon-consultation'
import BonAnalyse from '@/components/caisse/factures/print-bons/bon-analyse'
import BonExamen from '@/components/caisse/factures/print-bons/bon-examen'

export default {
    name: 'print-bons',
    components: {
        BonConsultation, BonAnalyse,
        BonExamen
    },
    props: [],
    data() {
        return {
            tab_to_show: 'consultation'
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        changeTab(tab) {
            this.tab_to_show = tab
        },
    }
}